<template>
	<div class="component-main">
		<div class="d-md-none mobile-main">
			<mobile-customer-slot-calendar />
		</div>
		<div class="d-none d-md-block desktop-main">
			<desktop-customer-slot-calendar />
		</div>
	</div>
</template>
<script>
import MobileCustomerSlotCalendar from './MobileCustomerSlotCalendar'
import DesktopCustomerSlotCalendar from './DesktopCustomerSlotCalendar'
import {mixin} from '../mixins/clickAndCollectMixins'
export default{
	name: 'CustomerSlots',
	components: {MobileCustomerSlotCalendar, DesktopCustomerSlotCalendar},
	props: [],
	mixins: [mixin],
	data(){
		return{

		}
	},
	created(){
	},
	methods: {

	}
}

</script>
<style>
.component-main
{
	min-width: 320px;
}
// Extra small devices (portrait phones, less than 576px)
@media (max-width: 575.98px) { }

// Small devices (landscape phones, less than 768px)
@media (max-width: 767.98px) { }

// Medium devices (tablets, less than 992px)
@media (max-width: 991.98px) { }

// Large devices (desktops, less than 1200px)
@media (max-width: 1199.98px) {  }

</style>